function getMonitorSerial() {
    const d = new Date()
    const y = d.getFullYear()
    const M = String(d.getMonth() + 1).padStart(2, '0')
    const day = String(d.getDate()).padStart(2, '0')
    const h = String(d.getHours()).padStart(2, '0')
    const m = String(d.getMinutes()).padStart(2, '0')
    const s = String(d.getSeconds()).padStart(2, '0')
    const SSS = String(d.getMilliseconds()).padStart(3, '0')
    return `${y}${M}${day}${h}${m}${s}${SSS}`
}
export default getMonitorSerial